import React, { FC, memo } from 'react';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { getOptionsWithEmptyOption } from '../../../shared/utils';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum } from '../../shared/types';
import { StyledFormikSelect } from '../../shared/styles';

type Props = FilterData;

const VehicleType: FC<Props> = ({ name, label }) => {
  const { getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.vehicle);

  return (
    <>
      <Label>{label}</Label>
      <StyledFormikSelect
        saveAsOption
        name={name}
        size="small"
        options={getOptionsWithEmptyOption(getMatchedSearchOptions(name))}
      />
    </>
  );
};

export default memo(VehicleType);
